module.exports = __webpack_public_path__ + "img/proposal_background-xs.fbf9b197.jpg";